import { computeValue } from "../../../core";
import { dateAdd } from "./_internal";
const $dateAdd = (obj, expr, options) => {
  const args = computeValue(obj, expr, null, options);
  return dateAdd(args.startDate, args.unit, args.amount, args.timezone);
};
export {
  $dateAdd
};
